'use client';

import { useStyle } from '@/classify';
import { useForgotPasswordPage } from '@/hooks/ForgotPasswordPage/useForgotPasswordPage';
import Image from 'next/image';
import ForgotPassword from '../ForgotPassword';

import defaultClasses from './forgotPasswordPage.module.css';

const ForgotPasswordPage = props => {
  const classes = useStyle(defaultClasses, props.classes);
  const { forgotPasswordProps } = useForgotPasswordPage(props);

  return (
    <div className=''>
      <div className=''>
        <Image
          src='/signIn.jpg'
          alt='forgotPassword'
          width={3840}
          height={740}
          className='hidden w-full object-cover lg_block lg_min-h-[370px]'
        />
        <ForgotPassword {...forgotPasswordProps} />
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
